"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Ripple = _createStyled["default"].div(_templateObject(), function (props) {
  return props.animation;
}),
    RippleContainer = _createStyled["default"].div(_templateObject2()),
    Digit = _createStyled["default"].button(_templateObject3()),
    Clear = _createStyled["default"].span(_templateObject4()),
    Delete = _createStyled["default"].span(_templateObject5()),
    Bullet = _createStyled["default"].div(_templateObject6()),
    BulletWrapper = _createStyled["default"].div(_templateObject7()),
    Dial = _createStyled["default"].div(_templateObject8()),
    Root = _createStyled["default"].div(_templateObject9()),
    HiddenInput = _createStyled["default"].input(_templateObject10()),
    Label = _createStyled["default"].label(_templateObject11());

function template() {
  var _this = this;

  var _this$props = this.props,
      value = _this$props.value,
      label = _this$props.label,
      collection = _this$props.collection,
      maxLength = _this$props.maxLength,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      onChange = _this$props.onChange,
      animationItems = this.state.animationItems,
      styles = this.compileStyled(_index["default"]),
      digits = [],
      bullets = [],
      filledCount = value ? value.length : 0;
  var labelContent = null,
      i = 0,
      lastDigit;

  if (label) {
    labelContent = _react["default"].createElement(Label, {
      styles: styles.label
    }, label);
  }

  collection.forEach(function (value, i) {
    if (i === 9) return;
    digits.push(_react["default"].createElement(Digit, {
      key: "digit-".concat(value),
      styles: styles.digit,
      type: "button",
      onClick: function onClick(e) {
        return _this.select(value, e);
      }
    }, _react["default"].createElement("span", null, String(value))));
  });
  lastDigit = collection[collection.length - 1];
  digits.push(_react["default"].createElement(Digit, {
    styles: styles.digit,
    type: "button",
    key: "digit-clear",
    onClick: this.clear
  }, _react["default"].createElement(Clear, {
    styles: styles.clear
  })), _react["default"].createElement(Digit, {
    styles: styles.digit,
    type: "button",
    key: "digit-".concat(lastDigit),
    onClick: function onClick(e) {
      return _this.select(lastDigit, e);
    }
  }, _react["default"].createElement("span", null, lastDigit)), _react["default"].createElement(Digit, {
    styles: styles.digit,
    type: "button",
    key: "digit-c",
    onClick: this.clearDigit
  }, _react["default"].createElement(Delete, {
    styles: styles.deleteDigit
  })));

  for (i; i < maxLength; i++) {
    bullets.push(_react["default"].createElement(Bullet, {
      key: "bullet-".concat(i),
      styles: i < filledCount ? styles.bulletFilled : styles.bullet
    }));
  }

  return _react["default"].createElement(Root, {
    styles: styles.root,
    className: className
  }, labelContent, _react["default"].createElement(BulletWrapper, {
    styles: styles.bulletWrapper
  }, bullets), _react["default"].createElement(Dial, {
    styles: styles.dial
  }, _react["default"].createElement(RippleContainer, {
    styles: styles.animationContainer
  }, animationItems.map(function (item) {
    return _react["default"].createElement(Ripple, {
      key: item.key,
      animation: styles.animationFunction,
      styles: _objectSpread({}, styles.animationRules, {
        top: "".concat(item.top, "px"),
        left: "".concat(item.left, "px")
      }),
      onAnimationEnd: item.onAnimationEnd
    });
  })), digits, _react["default"].createElement(HiddenInput, {
    type: "text",
    value: this._stringify(),
    onChange: onChange,
    ref: this._inputRef,
    styles: styles.input
  })));
}